'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { isSessionValid } from '@lichtblick/auth';
import { consumePendingLogoutRedirectUrl } from '@lichtblick/utils';

type RedirectManagerProps = {
  roles: string[];
  searchParams?: {
    callbackUrl?: string;
  };
  session: {
    access_token: string;
    error?: 'RefreshTokenError';
    errorDetails?: unknown;
    expires: string;
    user?: {
      email?: string | null;
      image?: string | null;
      name?: string | null;
    };
  } | null;
};

export const RedirectManager = ({ roles, searchParams, session }: RedirectManagerProps) => {
  const router = useRouter();

  useEffect(() => {
    if (isSessionValid(session)) {
      const isPm = roles.includes('Project Manager') || roles.includes('Branch Manager');
      const isQm = roles.includes('Quality Manager');

      const pendingLogoutRedirectUrl = consumePendingLogoutRedirectUrl();
      const redirectUrl = searchParams?.callbackUrl ? searchParams.callbackUrl : pendingLogoutRedirectUrl;

      if (redirectUrl) {
        const isPmUrl = redirectUrl.includes('/pm') && isPm;
        const isQmUrl = redirectUrl.includes('/qm') && isQm;

        if (isPmUrl || isQmUrl) {
          router.push(redirectUrl);
        } else {
          router.push('/qm/orders');
        }
      } else if (isPm) {
        router.push('/pm');
      } else if (isQm) {
        router.push('/qm/orders');
      } else {
        router.push('/logout');
      }
    }
  }, [roles, router, searchParams?.callbackUrl, session]);

  return <></>;
};
